import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { useAddCareplanCartLine } from "@/domains/careplan/mutations/use-add-careplan-cart-line";
import { useCartSellingPlans } from "@/domains/careplan/queries/use-cart-selling-plans";

/* Shopify drops a line at quantity 0, so restoring is an add by merchandise id, not an update. */
export const useRestoreCareplanCartLine = () => {
  const { cartVariantIds } = useCareplanContext();
  const { data: availableSellingPlans } = useCartSellingPlans(cartVariantIds);
  const { isPending, mutate } = useAddCareplanCartLine();
  const monthlySellingPlanId = availableSellingPlans?.monthly?.id;

  const restore = (cartId: string, line: { merchandiseId: string }) => {
    if (!monthlySellingPlanId) {
      return;
    }

    mutate({
      cartId,
      lines: [
        {
          merchandiseId: line.merchandiseId,
          quantity: 1,
          sellingPlanId: monthlySellingPlanId,
        },
      ],
    });
  };

  return { canRestore: !!monthlySellingPlanId, isPending, restore };
};
